import {BaseService} from "./BaseService";
import {
	actionUserFetchCompleted
} from "../store/users/actions";
import {ReportsAPI} from "../api/ReportsAPI";
import {InvoicePaymentPeriod} from "../models/reports/InvoicePaymentPeriod";
import {actionReportsInvoicesPaymentsCompleted, actionReportsServicesCompleted} from "../store/reports";
import * as moment  from "moment"
import {ErrorService} from "./ErrorService";
import {ServicePaymentInvoice} from "../models/reports/ServicePaymentInvoice";

export default class ReportsService extends BaseService {

	static getInvoicesAndPaymentsPerPeriod () {
		const api: ReportsAPI = new ReportsAPI()
		api.invoicesAndPaymentsPerPeriod().then(ReportsService.processResponse)
		.then((data) => {
			actionReportsInvoicesPaymentsCompleted(ReportsService.responseToInvoicePaymentPeriods(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static getServicesPerPeriod (fromDate: Date, toDate: Date) {
		const api: ReportsAPI = new ReportsAPI()
		api.servicesPerPeriod(fromDate, toDate).then(ReportsService.processResponse)
			.then((data) => {
				actionReportsServicesCompleted(ReportsService.responseToServicePaymentInvoices(data))
			})
			.catch(error => ErrorService.handleError(error))
	}

	static responseToInvoicePaymentPeriod (data: any): any {
		// let ipp = new InvoicePaymentPeriod()
		// ipp.period = data.period
		// ipp.invoicesValue = data.invoicesValue
		// ipp.paymentsValue = data.lastName
		// ipp.vatValue = data.email
		// return ipp

		return data
	}

	static responseToInvoicePaymentPeriods (data: any): any[] {
		return data
		// let ipps: InvoicePaymentPeriod[] = []
		// for (let ipp of data) {
		// 	ipps.push(ReportsService.responseToInvoicePaymentPeriod(ipp))
		// }
		// return ipps
	}

	static responseToServicePaymentInvoices (data: any): any[] {
		return data
		// let ipps: InvoicePaymentPeriod[] = []
		// for (let ipp of data) {
		// 	ipps.push(ReportsService.responseToInvoicePaymentPeriod(ipp))
		// }
		// return ipps
	}

	static prepareReport(data: any, from: Date, to: Date): InvoicePaymentPeriod[] {
		let ipps: InvoicePaymentPeriod[] = []
		let months = ReportsService.prepareMonths(from, to)
		for (let month of months) {
			let ipp = new InvoicePaymentPeriod()
			ipp.period = month
			ipp.invoicesValue = ReportsService.findValue(month, 'invoice', data)
			ipp.paymentsValue = ReportsService.findValue(month, 'payment', data)
			ipp.vatValue = 0
			ipps.push(ipp)
		}
		return  ipps
	}

	static prepareBookingReport(data: any): ServicePaymentInvoice[] {
		let spis: ServicePaymentInvoice[] = []
		for (let item of data) {
			let spi = new ServicePaymentInvoice()
			spi.invoicesValue = item.invoiceValue
			spi.service = item.name
			spis.push(spi)
		}
		return spis
	}

	static findValue (month: string, type: string, rawData: any[] ): number {
		for (let item of rawData) {
			if (item.type == type && item.date == month) return item.price
		}
		return 0
	}

	static prepareMonths(from: Date, to: Date): string[] {
		let dates: string[] = []
		let date: Date = from
		while (moment(date).isBefore(moment(to))) {
			dates.push(moment(date).format("YYYY-MM"))
			date = moment(date).add(1,'month').toDate()
		}
		return dates
	}
}
